var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex w-full"},_vm._l((_vm.options),function(option,index){return _c('div',{key:index,staticClass:"text-lg px-4 cursor-pointer flex-no-shrink",class:{
      'pl-0': index === 0,
      'border-r': _vm.options.length - 1 > index
    },on:{"click":function($event){_vm.$emit('input', option)}}},[_c('span',{staticClass:"border-b-2 pb-2",class:[
        _vm.value === option ? 'border-secondary font-bold' : 'border-transparent'
      ]},[_vm._v("\n    "+_vm._s(option)+"\n    ")])])}))}
var staticRenderFns = []

export { render, staticRenderFns }